import { SIDEBAR_VIEWS, MAP_LAYER_IDS } from '../../../../lib/constants';
import AlertCircle from '../../../../assets/svg/Feather/AlertCircle';
import ghAnalytics from '../../../../lib/analytics';

export default (dispatch) => ({
  featureClicked: (selectedFeature) => {
    dispatch({
      type: 'features/setSelectedFeatureLoading',
      payload: true
    });
    dispatch({
      type: 'features/setIsEditingFeature',
      payload: false,
    })
    dispatch({
      type: 'app/gotoSidebarWithHistory',
      payload: SIDEBAR_VIEWS.FeatureDetail,
    });
    dispatch({
      type: 'features/getFeature',
      payload: selectedFeature.uuid,
      callback: (feature, error) => {
        if (feature) {
          dispatch({
            type: 'features/setSelectedFeature',
            payload: feature
          });
          dispatch({
            type: 'features/setPreviousFeatureState',
            payload: feature
          });
          dispatch({
            type: 'app/setSideBarScrollPosition',
            payload: { features: feature.uuid },
          })
          dispatch({
            type: 'map/goToFeature',
            payload: {
              featureId: feature.uuid,
              layerId: MAP_LAYER_IDS.content
            }
          });
        } else {
          dispatch({
            type: 'app/navSidebarBack'
          });
          dispatch({
            type: 'features/setSelectedFeature',
            payload: null
          });
          let toastPayloadText = 'Oops, there was an issue retrieving the feature'
          if (error.status == 404) {
            toastPayloadText = 'Sorry, but it looks like that feature does not exist'
            dispatch({
              type: 'features/removeFeatureFromUserDataEffect',
              payload: selectedFeature.uuid
            })
          }
          dispatch({
            type: 'toast/show',
            payload: {
              dismissable: true,
              icon: AlertCircle,
              iconColor: '#FF3B30',
              text: toastPayloadText,
            }
          });
        }
        dispatch({
          type: 'features/setSelectedFeatureLoading',
          payload: false
        });
      }
    });
  },

  toggleCheckboxAll: () => {
    dispatch({
      type: 'collections/toggleAllCollectionCheckboxes'
    });
  },

  toggleAllFeaturesVisibility: (collection, visibility) => {
    dispatch({
      type: 'features/setFeaturesVisibility',
      payload: { collectionId: collection.uuid, visibility, type: 'collection' }
    });
  },

  toggleFeatureVisibility: (feature, visibility) => {
    dispatch({
      type: 'features/setFeaturesVisibility',
      payload: { featureId: feature.uuid, visibility: visibility, type: 'feature' }
    });
    ghAnalytics.logVisibility(visibility, feature);
  }
});